var getLabel = function getLabel(resource) {
  return resource.label || null;
};

var getDescription = function getDescription(resource) {
  return resource.description || null;
};

var getAttribution = function getAttribution(resource) {
  return resource.attribution || null;
};

var getMetadata = function getMetadata(resource) {
  return resource.metadata || [];
};

// Returns ID to service.
var getThumbnailId = function getThumbnailId(resource) {
  if (Array.isArray(resource.thumbnail)) {
    return resource.thumbnail[0];
  }
  return resource.thumbnail || null;
};

var getLicense = function getLicense(resource) {
  if (!resource.license) {
    return null;
  }
  if (Array.isArray(resource.license)) {
    return resource.license;
  }
  return [resource.license];
};

var getLogo = function getLogo(resource) {
  if (!resource.logo) {
    return null;
  }
  if (Array.isArray(resource.logo)) {
    return resource.logo[0]['@id'] || resource.logo[0];
  }
  return resource.logo['@id'] || resource.logo;
};

export { getLabel, getMetadata, getDescription, getThumbnailId, getAttribution, getLicense, getLogo };